import { RequestFactory } from "@/requests/RequestFactory";
const logicaIntervencaoRequest = RequestFactory.get("logicaIntervencao");

export default {
  namespaced: true,

  state: {
    isFetching: false,
    items: {}
  },

  mutations: {
    FETCHING_OFF(state) {
      state.isFetching = false;
    },
    FETCHING_ON(state) {
      state.isFetching = true;
    },
    SET_RESUMO_INDICADOR(state, payload) {
      state.items[payload.logicaIntervencaoId]['resumoIndicador'] = payload.resumoIndicador
    },
    SET_RESUMO_ATIVIDADE(state, payload) {
      state.items[payload.logicaIntervencaoId]['resumoAtividade'] = payload.resumoAtividade
    },
    SET_PROGRESSO_LOGICA_INTERVENCAO(state, payload) {
      state.items[payload.logicaIntervencaoId]['progressoLogicaIntervencao'] = payload.progressoLogicaIntervencao
    },
  },  

  actions: {
    requestOn({commit}) { commit('FETCHING_ON'); },
    requestOff({commit}) { commit('FETCHING_OFF'); },

    fetchLogicaIntervencao: ({ dispatch }, { logicaIntervencaoId }) => dispatch('fetchItem', { resource: 'logicaIntervencao', logicaIntervencaoId }, { root: true }),

    fetchLogicaIntervencoes: ({ dispatch }, projetoId) => {
      const payload = { resource: 'logicaIntervencao', id: projetoId }
      //return dispatch('fetchItemsParent', payload, { root: true })
      return dispatch('fetchIntervencoesByProjeto', payload, { root: true })

      
    },

    criarLogicaIntervencao({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return logicaIntervencaoRequest.post(payload.projetoId, payload.logicaIntervencao).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'logicaIntervencao', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Lógica de intercenção criada com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    editarLogicaIntervencao({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return logicaIntervencaoRequest.editar(payload.projeto.id, payload).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'logicaIntervencao', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Lógica de intercenção atualizada com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })

        return response.data
      })
    },

    excluirLogicaIntervencao({ commit, dispatch }, payload) {
      dispatch('requestOn');
      const projetoId = payload.projetoId;
      const logicaIntervencaoId = payload.logicaIntervencaoId;
      return logicaIntervencaoRequest.delete(projetoId, logicaIntervencaoId).then(() => {
        dispatch('requestOff');
        const payload = { resource: 'logicaIntervencao', itemId: logicaIntervencaoId }
        commit('deleteItem', payload, { root: true })
        const notification = {
          type: 'success',
          message: 'Lógica de intercenção removida com sucesso.'
        }
        return dispatch('notification/add', notification, { root: true })
      })
    },


    deleteAtividade({ commit, dispatch }, atividadeId) {
      dispatch('requestOn');
      return logicaIntervencaoRequest.delete(atividadeId).then(() => {
        dispatch('requestOff');
        const payload = { resource: 'logicaIntervencao', itemId: atividadeId }
        commit('deleteItem', payload, { root: true })
        const notification = {
          type: 'success',
          message: 'Atividade removida com sucesso'
        }
        return dispatch('notification/add', notification, { root: true })
      })
    },

    deleteResultadoEsperado({ commit, dispatch }, ResultadoEsperadoId) {
      dispatch('requestOn');
      return logicaIntervencaoRequest.delete(ResultadoEsperadoId).then(() => {
        dispatch('requestOff');
        const payload = { resource: 'logicaIntervencao', itemId: ResultadoEsperadoId }
        commit('deleteItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Resultado Esperado removido com sucesso'
        }

        return dispatch('notification/add', notification, { root: true })
      })
    },

    actionAivarOuDesativarEdicao({ commit, dispatch }, payload) {
      dispatch('requestOn');
      return logicaIntervencaoRequest.ativarOuDesativarEdicao(payload).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'logicaIntervencao', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: response.data.edicao ? 'Lógica de intervenção edição habilitada com sucesso.' : 'Lógica de intervenção edição desabilitada com sucesso.'
        }
        dispatch('notification/add', notification, { root: true })

        return response.data
      })
    },

  },

  getters: {
    byProjeto: (state) => projetoId => {
      if (state.items) {
        return Object.values(state.items)
          .filter(logicaIntervencao => logicaIntervencao.projeto.id === projetoId)
          .sort((a, b) => (a.posicaoFormatada > b.posicaoFormatada) ? 1 : ((b.posicaoFormatada > a.posicaoFormatada) ? -1 : 0));
      }
      return []
    },


    produtosByProjeto: (state, getters) => projetoId => {      
      if (state.items) {
        var produtos = Object.values(state.items)
          .filter(logicaIntervencao => logicaIntervencao.projeto.id === projetoId && logicaIntervencao.nivel === "RESULTADO_ESPERADO")
          .sort((a, b) => (a.posicaoFormatada > b.posicaoFormatada) ? 1 : ((b.posicaoFormatada > a.posicaoFormatada) ? -1 : 0))

        produtos.forEach((entry) => {
          if (typeof entry === "object") {
            entry["atividades"] = getters.atividadesByProduto(entry.id)
          }
        });
        return produtos;
      }
      return []
    },

    impactosByProjeto: (state) => projetoId => {
      if (state.items) {
        return Object.values(state.items)
          .filter(logicaIntervencao => logicaIntervencao.projeto.id === projetoId && logicaIntervencao.nivel === "OBJETIVO_GERAL")
          .sort((a, b) => (a.posicaoFormatada > b.posicaoFormatada) ? 1 : ((b.posicaoFormatada > a.posicaoFormatada) ? -1 : 0));
      }
      return []
    },

    realizacoesByProjeto: (state, getters) => projetoId => {
      if (state.items) {
        var realizacoes = Object.values(state.items)
          .filter(logicaIntervencao => logicaIntervencao.projeto.id === projetoId && logicaIntervencao.nivel === "OBJETIVO_ESPECIFICO")
          .sort((a, b) => (a.posicaoFormatada > b.posicaoFormatada) ? 1 : ((b.posicaoFormatada > a.posicaoFormatada) ? -1 : 0));

        realizacoes.forEach((entry) => {
          if (typeof entry === "object") {
            entry["produtos"] = getters.produtosByRealizacao(entry.id)
          }
        });

        return realizacoes;
      }
      return []
    },

    produtosByRealizacao: (state, getters) => realizacaoId => {
      if (state.items) {
        var produtos = Object.values(state.items)
          .filter(logicaIntervencao => logicaIntervencao.logicaIntervencao && logicaIntervencao.logicaIntervencao.id === realizacaoId && logicaIntervencao.nivel === "RESULTADO_ESPERADO")
          .sort((a, b) => (a.posicaoFormatada > b.posicaoFormatada) ? 1 : ((b.posicaoFormatada > a.posicaoFormatada) ? -1 : 0))

        produtos.forEach((entry) => {
          if (typeof entry === "object") {
            entry["atividades"] = getters.atividadesByProduto(entry.id)
          }
        });

        return produtos;
      }
      return []
    },

    atividadesByProduto: (state) => produtoId => {
      if (state.items) {
        return Object.values(state.items)
          .filter(logicaIntervencao =>
            logicaIntervencao.logicaIntervencao && logicaIntervencao.logicaIntervencao.id === produtoId && logicaIntervencao.nivel === 'ATIVIDADE'
          )
          .sort((a, b) => (a.posicaoFormatada > b.posicaoFormatada) ? 1 : ((b.posicaoFormatada > a.posicaoFormatada) ? -1 : 0))
      }
      return []
    },

    byId: (state) => logicaIntervencaoId => {
      if (state.items) {
        return Object.values(state.items)
          .find(logicaIntervencao => logicaIntervencao.id === logicaIntervencaoId)
      }
      return {}
    },

    produtoById: (state) => logicaIntervencaoId => {
      if (state.items) {
        return Object.values(state.items)
          .find(logicaIntervencao => logicaIntervencao.id === logicaIntervencaoId)
      }
      return {}
    },

    objetivoGeral: (state) => projetoId => {
      if (state.items) {
        return Object.values(state.items)
          .find(logicaIntervencao => logicaIntervencao.projeto.id === projetoId && logicaIntervencao.nivel === "OBJETIVO_GERAL")
      }
      return {}
    },

    objetivoEspecifico: (state) => projetoId => {
      if (state.items) {
        return Object.values(state.items)
          .find(logicaIntervencao => logicaIntervencao.projeto.id === projetoId && logicaIntervencao.nivel === 'OBJETIVO_ESPECIFICO')
      }
      return {}
    },

    resultados: (state) => projetoId => {
      if (state.items) {
        return Object.values(state.items)
          .filter(logicaIntervencao => logicaIntervencao.projeto.id === projetoId && logicaIntervencao.nivel === 'RESULTADO_ESPERADO')
      }
      return []
    },

    atividades: (state) => (projetoId, resultadoEsperadoId) => {
      if (state.items) {
        return Object.values(state.items)
          .filter(logicaIntervencao =>
            logicaIntervencao.logicaIntervencao && logicaIntervencao.projeto.id === projetoId && logicaIntervencao.logicaIntervencao.id === resultadoEsperadoId && logicaIntervencao.nivel === 'ATIVIDADE'
          )
      }
      return []
    },

    atividadesPorResultado: (state) => (resultadoEsperadoId) => {
      if (state.items) {
        return Object.values(state.items)
          .filter(logicaIntervencao =>
            logicaIntervencao.logicaIntervencao && logicaIntervencao.logicaIntervencao.id === resultadoEsperadoId && logicaIntervencao.nivel === 'ATIVIDADE'
          ).sort((a, b) => (a.posicao > b.posicao) ? 1 : ((b.posicao > a.posicao) ? -1 : 0))
      }
      return []
    },

    atividadePorProjeto: (state) => (projetoId) => {
      if (state.items) {
        return Object.values(state.items)
          .filter(logicaIntervencao =>
            logicaIntervencao.logicaIntervencao && logicaIntervencao.projeto.id === projetoId && logicaIntervencao.nivel === 'ATIVIDADE'
          ).sort(
            function (a, b) {
              if (a.logicaIntervencao.posicao === b.logicaIntervencao.posicao) {
                return a.posicao - b.posicao;
              }
              return a.logicaIntervencao.posicao > b.logicaIntervencao.posicao ? 1 : -1;
            });
      }
      return []
    },
  },
}